import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  CanLoad,
  Route,
  Router,
  RouterStateSnapshot,
  UrlSegment,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { Deployment } from 'src/app/core/interfaces/deployment';
import { DeploymentsService } from '../deployments.service';

@Injectable({
  providedIn: 'root',
})
export class SdsRunningGuard implements CanActivate {
  constructor(private deploymentsService: DeploymentsService) {}

  /**
   * Can activate
   *
   * @param route
   * @param state
   */
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (!this.deploymentsService.deployments) return true;
    if (route.paramMap.get('deploymentId') == '') return false;
    const currentDeployment = this.deploymentsService.findDeployment(
      this.deploymentsService.deployments,
      route.paramMap.get('deploymentId'),
    ) as Deployment;
    if (!currentDeployment) return false;
    if (currentDeployment.deploymenttype != 'sds') return false;
    //TODO: add in checks once we get status returning back properly
    //if (currentDeployment.status != 'COMPLETE') return false;
    //if (currentDeployment.service_status != 'RUNNING') return false;
    return true;
  }
}
